import { render, staticRenderFns } from "./LogUpdateModalStep2.vue?vue&type=template&id=24c263ad&"
import script from "./LogUpdateModalStep2.vue?vue&type=script&lang=js&"
export * from "./LogUpdateModalStep2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports